/* MTM: the code "MTM VIP+" only counts while the VIP+ membership is in the cart (Tom, 29-10-2026).
   Runs on every page and after every cart refresh. When the membership line is missing and the code is still applied,
   it clears the code from the cart and removes the stored discount cookie. It waits 1.5 s and checks again first,
   so it never fights the VIP+ add step in mtm-cart.js. */
(function () {
  var HANDLE = 'cozy-cuddles-vip';
  var busy = false;

  function cookieHasCode() {
    try {
      var m = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
      return !!m && decodeURIComponent(m[1]).toLowerCase().indexOf('vip+') > -1;
    } catch (e) { return false; }
  }
  function dropCookie() {
    try { document.cookie = 'discount_code=; Max-Age=0; path=/'; } catch (e) {}
  }
  function state() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var items = c.items || [];
        var hasVip = items.some(function (i) { return i.handle === HANDLE; });
        var s = JSON.stringify([c.cart_level_discount_applications, items.map(function (i) { return i.discounts; })]).toLowerCase();
        return { hasVip: hasVip, codeOn: s.indexOf('vip+') > -1 };
      });
  }
  function run() {
    if (busy) return;
    busy = true;
    state().then(function (a) {
      if (a.hasVip || (!a.codeOn && !cookieHasCode())) { busy = false; return; }
      setTimeout(function () {
        state().then(function (b) {
          if (b.hasVip) { busy = false; return; }
          var p = b.codeOn
            ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: '' }) })
                .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } })); })
            : Promise.resolve();
          return p.then(function () { dropCookie(); busy = false; });
        }).catch(function () { busy = false; });
      }, 1500);
    }).catch(function () { busy = false; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('cart:refresh', function () { setTimeout(run, 900); });
})();
